import * as React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";

export default function USRIView(props) {
	const { reportData, reportType } = props;
	/* console.log("reportData", reportData);
	console.log("reportType", reportType); */

	const { header, pub_results, indiv_results, chair_results, labels, class_data } = reportData;

	const results = pub_results || indiv_results || chair_results;

	const reqNumKey = header?.requisition?.split("-")[0];
	const ratingRows = results?.[reqNumKey][0].rating_items || [];

	const comments = results?.[reqNumKey][0].comments;
	//297x210 mm
	const pageWidth = 297; // mm
	const pageHeight = 210; // mm
	const marginLeft = 10,
		marginTop = 10,
		marginRight = 10;
	const headerHeight = 25; // space reserved for header
	function drawHeader(doc, headerData, pageWidth, startY = marginTop) {
		// Set fonts and sizes as needed

		doc.setFont("roboto", "normal");
		doc.setFontSize(10);
		const ctitle = header?.class_title.trim();
		const instructor = header?.instructor.trim();
		const reportDate = header?.report_date.trim();
		const department = header?.department.trim();
		const faculty = header?.faculty.trim();
		const academicYear = header?.academic_year.trim();
		const catalog = header?.catalog.trim();
		const requisition = header?.requisition.trim();
		doc.text("Instructor: ", marginLeft, startY);
		doc.text("Class: ", marginLeft, startY + 5);
		doc.text("Department: ", marginLeft, startY + 10);
		doc.text("Faculty: ", marginLeft, startY + 15);
		doc.text(reportDate, 285, startY, { align: "right" });
		doc.text("Academic Year: ", 273, startY + 5, { align: "right" });
		doc.text("Catalog: ", 277, startY + 10, { align: "right" });
		doc.text("Requisition Number: ", 268, startY + 15, { align: "right" });

		doc.setFont("roboto", "bold");
		doc.text(instructor, 26, startY);
		doc.text(ctitle, 20, startY + 5);
		doc.text(department, 29, startY + 10);
		doc.text(faculty, 23, startY + 15);
		doc.text(academicYear, 285, startY + 5, { align: "right" });
		doc.text(catalog, 285, startY + 10, { align: "right" });
		doc.text(requisition, 285, startY + 15, { align: "right" });

		doc.setFont("roboto", "normal");
		doc.setFontSize(10);

		// Center title
		doc.setFont("roboto", "bold");
		doc.setFontSize(12);
		doc.text("Universal Student Ratings of Instruction", pageWidth / 2, startY, {
			align: "center",
		});

		// Reset font for content
		doc.setFont("roboto", "normal");
		doc.setFontSize(10);
		doc.rect(marginLeft, 27, pageWidth - marginLeft - marginRight, 0.1); // Draw a line under the header

		// Return the next available Y coordinate after the header
		return startY + headerHeight;
	}

	function drawCommentsSection(doc, comments, currentY, availableHeight, headerData) {
		// Force new page for comments:
		if (ratingRows.length > 0) doc.addPage();
		currentY = drawHeader(doc, headerData, pageWidth);
		doc.setFont("roboto", "bold");
		doc.text("USRI COMMENTS", pageWidth / 2, currentY, { align: "center" });
		doc.setFont("roboto", "normal");
		currentY += 7;

		Object.entries(comments).forEach(([key, commentArray]) => {
			const parts = key.replace(/[()]/g, "").split(",");
			const itemNumber = parts[1]?.trim();
			// remove quotes from the item text
			const itemText = parts
				.slice(2)
				.join(",")
				.trim()
				// eslint-disable-next-line no-control-regex
				.replace(/['"\\\x00]/g, "");

			const normalText = "Comment Item Number " + itemNumber + ": ";
			const boldText = itemText;
			const headerLineHeight = 5;

			if (currentY + headerLineHeight > availableHeight) {
				doc.addPage();
				currentY = drawHeader(doc, headerData, pageWidth);
			}
			// Draw the header text in two parts:
			doc.setFont("roboto", "normal");
			doc.text(normalText, marginLeft, currentY);
			const normalTextWidth = doc.getTextWidth(normalText);
			doc.setFont("roboto", "bold");
			doc.text(boldText, marginLeft + normalTextWidth, currentY);
			// Draw a line under the header
			doc.rect(marginLeft, currentY + 1, pageWidth - marginLeft - marginRight, 0.1);
			// Reset font back to normal for subsequent text
			doc.setFont("roboto", "normal");
			currentY += headerLineHeight + 1;

			commentArray.forEach((comment) => {
				// Calculate maximum width for comment text
				const maxWidth = pageWidth - marginRight - (marginLeft + 5);
				// Split comment text into lines that fit within maxWidth
				const splittedComment = doc.splitTextToSize(comment, maxWidth);
				const lineHeight = 5;
				const totalCommentHeight = splittedComment.length * lineHeight;

				if (currentY + totalCommentHeight > availableHeight) {
					doc.addPage();
					currentY = drawHeader(doc, headerData, pageWidth);
					doc.setFont("roboto", "bold");
					doc.text("USRI COMMENTS (CONTINUED)", pageWidth / 2, currentY, {
						align: "center",
					});
					currentY += 7;
					// Write comment header for continuation using mixed fonts
					const normalTextCont = "Comment Item Number " + itemNumber + " (continued): ";
					const boldTextCont = itemText;
					doc.setFont("roboto", "normal");
					doc.text(normalTextCont, marginLeft, currentY);
					const normalTextWidthCont = doc.getTextWidth(normalTextCont);
					doc.setFont("roboto", "bold");
					doc.text(boldTextCont, marginLeft + normalTextWidthCont, currentY);
					doc.rect(marginLeft, currentY + 1, pageWidth - marginLeft - marginRight, 0.1);
					doc.setFont("roboto", "normal");
					currentY += headerLineHeight + 1;
				}

				// Draw the comment text
				doc.text(splittedComment, marginLeft + 5, currentY);
				currentY += totalCommentHeight;

				// only add dotted line if not the last comment in the array
				if (comment !== commentArray[commentArray.length - 1]) {
					// Set a dotted line style: [dashLength, gapLength]
					doc.setLineDash([1, 2]);
					doc.setDrawColor(150); // Set color for the line (optional)
					// Draw the horizontal dotted line across the comment area
					doc.line(
						marginLeft + 5,
						currentY - lineHeight / 2,
						pageWidth - marginRight,
						currentY - lineHeight / 2
					);
					// Reset line dash to solid (optional)
					doc.setLineDash([]);

					// Add extra spacing after the dotted line
					currentY += 2;
					doc.setDrawColor(0); // Reset color to default
				}
			});

			// Add extra spacing after each comment group
			currentY += 3;
		});
		return currentY;
	}
	const generatePDF = () => {
		const headerData = {
			instructor: header?.instructor.trim(),
			class_title: header?.class_title.trim(),
			department: header?.department.trim(),
			faculty: header?.faculty.trim(),
			report_date: header?.report_date.trim(),
			academic_year: header?.academic_year.trim(),
			catalog: header?.catalog.trim(),
			requisition: header?.requisition.trim(),
		};
		const fileName = `${headerData.class_title}_${headerData.instructor}_${headerData.academic_year}.pdf`;

		const doc = new jsPDF("l", "mm", "a4");

		let currentY;

		if (ratingRows.length > 0) {
			currentY = drawHeader(doc, headerData, pageWidth);
			const head = [
				[
					{ content: "ITEM", rowSpan: 2, styles: { halign: "left" } },
					{
						content: "RESPONSES FROM THIS CLASS",
						colSpan: 5,
						styles: { halign: "center" },
					},
					{ content: "CLASS MEDIAN", rowSpan: 2, styles: { halign: "center" } },
					{
						content: "RANKS OF MEDIANS FROM OTHER CLASSES",
						colSpan: 5,
						styles: { halign: "center" },
					},
				],
				[
					{ content: "SD", styles: { halign: "center" } },
					{ content: "D", styles: { halign: "center" } },
					{ content: "N", styles: { halign: "center" } },
					{ content: "A", styles: { halign: "center" } },
					{ content: "SA", styles: { halign: "center" } },
					{ content: "Tukey Fence", styles: { halign: "center" } },
					{ content: "25th", styles: { halign: "center" } },
					{ content: "50th", styles: { halign: "center" } },
					{ content: "75th", styles: { halign: "center" } },
					{ content: "Total Classes", styles: { halign: "center" } },
				],
			];

			const body = ratingRows.map((row) => {
				// For rows with custom reference type, show a single cell spanning the 5 columns for ranks.
				if (row.ref_type === "custom") {
					return [
						row.item_text,
						row.rsp1,
						row.rsp2,
						row.rsp3,
						row.rsp4,
						row.rsp5,
						row.median,
						{
							content: "no data available",
							colSpan: 5,
							styles: { halign: "center" },
						},
					];
				} else if (row.ref_type === "too_few") {
					return [
						row.item_text,
						row.rsp1,
						row.rsp2,
						row.rsp3,
						row.rsp4,
						row.rsp5,
						row.median,
						{
							content: "too few uses for rating",
							colSpan: 5,
							styles: { halign: "center" },
						},
					];
				} else {
					// For standard rows, split the rank data accordingly.
					const refParts = row.ref_data ? row.ref_data.split("   ") : [];
					return [
						row.item_text,
						row.rsp1,
						row.rsp2,
						row.rsp3,
						row.rsp4,
						row.rsp5,
						row.median,
						refParts[0] || "",
						refParts[1] || "",
						refParts[2] || "",
						refParts[3] || "",
						// Assume total classes comes from a different split (adjust as needed)
						row.ref_data ? row.ref_data.split("    ")[1] || "" : "",
					];
				}
			});
			const foot = [
				[
					{
						content: `Number of students responding to questionnaire: ${class_data.qtally} out of ${
							class_data.csize
						} (${((Number(class_data.qtally) / Number(class_data.csize)) * 100).toFixed(1)}%)`,
						colSpan: 12,
						styles: { halign: "left", cellPadding: { top: 4, left: 1 } },
					},
				],
				[
					{
						content:
							class_data.webct === "Yes"
								? "Responses from this class were collected online."
								: "Responses from this class were collected in person.",
						colSpan: 12,
						styles: { halign: "left" },
					},
				],
				[
					{
						content: labels.label,
						colSpan: 12,
						styles: { halign: "left", cellPadding: { top: 2, left: 1 } },
					},
				],
				[
					{
						content:
							"The reference data for the Universal Items is based on results beginning with Academic Year 2005/06 while other items use all data available.",
						colSpan: 12,
						styles: { halign: "left" },
					},
				],
				[
					{
						content:
							"Information about the contents of this report may be found on the Web at https://www.ualberta.ca/information-services-and-technology/services/test-scoring-questionnaire-services/student-perspectives-of-teaching.html",
						colSpan: 12,
						styles: { halign: "left" },
					},
				],
			];
			autoTable(doc, {
				head: head,
				body: body,
				foot: foot,
				// Set margins to leave space for your custom header (if drawn separately)
				margin: {
					top: headerHeight + marginTop - 5,
					left: marginLeft,
					right: marginRight,
				},
				styles: {
					font: "roboto",
					fontSize: 8,
					cellPadding: 1,
					overflow: "linebreak",
					halign: "left",
					valign: "middle",
					lineWidth: 0.1,
				},
				headStyles: {
					fillColor: [255, 255, 255], // no header shading
					textColor: [0, 0, 0],
					lineColor: [200, 200, 200],
				},
				// Override body styling (optional if you want alternating row shading)
				bodyStyles: {
					fillColor: [255, 255, 255], // no shading
					textColor: [0, 0, 0],
					lineColor: [200, 200, 200],
				},
				// Optionally add very light alternating row shading to help parse columns
				alternateRowStyles: {
					fillColor: [245, 245, 245],
				},
				// Override footer styling to remove cell lines/dividers
				footStyles: {
					fillColor: [255, 255, 255],
					textColor: [0, 0, 0],
					lineWidth: 0, // no borders in the footer
					/* padding: { top: 1, bottom: 1, left: 2, right: 2 }, */
				},
				columnStyles: {
					0: { cellWidth: 160 }, // force ITEM column to be 50 mm wide
					1: { halign: "center" },
					2: { halign: "center" }, // force RESPONSES FROM THIS CLASS column to be 20 mm wide
					3: { halign: "center" }, // force RESPONSES FROM THIS CLASS column to be 20 mm wide
					4: { halign: "center" }, // force RESPONSES FROM THIS CLASS column to be 20 mm wide
					5: { halign: "center" }, // force RESPONSES FROM THIS CLASS column to be 20 mm wide
					6: {
						cellWidth: 20,
						//align center
						halign: "center",
					}, // force RESPONSES FROM THIS CLASS column to be 20 mm wide
					7: { cellWidth: 14, halign: "center" }, // force CLASS MEDIAN column to be 20 mm wide
					8: { cellWidth: 10, halign: "center" }, // force 25th column to be 20 mm wide
					9: { cellWidth: 10, halign: "center" }, // force 50th column to be 20 mm wide
					10: { cellWidth: 10, halign: "center" }, // force 75th column to be 20 mm wide
					11: { cellWidth: 18, halign: "center" }, // force Total Classes column to be 20 mm wide
				},
				theme: "grid",
				didDrawCell: function (data) {
					if (data.section === "foot" && data.row.index === 0) {
						doc.setDrawColor(200); // Set color for the line (optional)
						data.doc.line(marginLeft, data.cell.y, pageWidth - marginRight, data.cell.y);
						doc.setDrawColor(0); // Reset color to default
					}
				},
			});

			currentY += doc.lastAutoTable.finalY + 10; // Adjust for the height of the table
		}
		const marginBottom = 20; // mm

		// If comments exist, add them on a new page:
		if (comments && reportType === "indiv") {
			drawCommentsSection(doc, comments, currentY, pageHeight - marginBottom, headerData);
		}

		doc.save(fileName);
	};

	const handleDownloadSingleReport = () => {
		// Call the function to generate the PDF
		generatePDF();
	};

	return (
		<div
			className={`mx-auto relative ${
				reportType !== "pub" ? " max-w-[99%] pt-[1%] " : "pt-[100px] max-w-[90%]"
			}`}
		>
			{reportType === "pub" && (
				<div className="absolute top-0 left-0 w-full h-full bg-black z-20 opacity-0"></div>
			)}

			{ratingRows.length > 0 && (
				<div className=" w-auto p-4  border border-gray-300   bg-white z-10 relative">
					{reportType !== "pub" && (
						<div className="absolute top-0 right-0">
							<button
								onClick={handleDownloadSingleReport}
								className="py-2 px-4 hover:cursor-pointer hover:ring-2 ring-inset underline  rounded-full text-primary transition duration-300 ease-in-out"
							>
								<span className=" font-semibold text-md">
									Download Single Report <DownloadIcon />
								</span>
							</button>
						</div>
					)}

					<div className="text-center  ">
						<h1 className="text-md font-bold">{header?.title}</h1>
					</div>

					<div className="flex justify-between items-start mb-2 text-sm">
						<div className="space-y-1">
							<p>
								Instructor: <span className="font-semibold">{header?.instructor}</span>
							</p>

							<p>
								Class: <span className="font-semibold">{header?.class_title}</span>
							</p>
							<p>
								Department: <span className="font-semibold">{header?.department}</span>
							</p>
							<p>
								Faculty: <span className="font-semibold">{header?.faculty}</span>
							</p>
						</div>
						<div className="text-right space-y-1">
							{/* <p className="font-semibold">USRI Report</p> */}
							<p>{header?.report_date}</p>
							<p>
								Academic Year: <span className="font-semibold">{header?.academic_year}</span>
							</p>
							<p>
								Catalog: <span className="font-semibold">{header?.catalog}</span>
							</p>
							{reportType !== "pub" && (
								<p>
									Requisition Number: <span className="font-semibold">{header?.requisition}</span>
								</p>
							)}
						</div>
					</div>
					{ratingRows.length > 0 && (
						<div className="overflow-x-auto">
							<table
								className="w-full text-xs border-collapse border border-gray-400"
								id="my-table"
							>
								<thead className="">
									<tr className="bg-gray-100">
										<th className="border border-gray-300 px-2 py-1 text-left w-auto " rowSpan="2">
											ITEM
										</th>
										<th
											colSpan="5"
											className="border border-gray-300 px-2 py-1 text-center min-w-[220px] "
										>
											RESPONSES FROM THIS CLASS
										</th>
										<th className="border border-gray-300 px-2 py-1 text-center w-20" rowSpan="2">
											CLASS MEDIAN
										</th>

										<th
											colSpan="5"
											className="border border-gray-300 px-2 py-1 text-center min-w-[220px] "
										>
											RANKS OF MEDIANS FROM OTHER CLASSES
										</th>
									</tr>
									<tr className="bg-gray-100">
										<th className="border border-gray-300 px-2 py-1 text-center">SD</th>
										<th className="border border-gray-300 px-2 py-1 text-center">D</th>
										<th className="border border-gray-300 px-2 py-1 text-center">N</th>
										<th className="border border-gray-300 px-2 py-1 text-center">A</th>
										<th className="border border-gray-300 px-2 py-1 text-center">SA</th>

										<th className="border border-gray-300 px-2 py-1 text-center">Tukey Fence</th>
										<th className="border border-gray-300 px-2 py-1 text-center">25th</th>
										<th className="border border-gray-300 px-2 py-1 text-center">50th</th>
										<th className="border border-gray-300 px-2 py-1 text-center">75th</th>
										<th className="border border-gray-300 px-2 py-1 text-center">Total Classes</th>
									</tr>
								</thead>
								<tbody>
									{ratingRows.map((row) => (
										<tr key={row.itemno} className="odd:bg-white even:bg-gray-50">
											<td className="border border-gray-300 px-2 py-1  overflow-auto max-w-[400px]">
												{row.item_text}
											</td>
											<td className="border border-gray-300 px-2 py-1 text-center">{row.rsp1}</td>
											<td className="border border-gray-300 px-2 py-1 text-center">{row.rsp2}</td>
											<td className="border border-gray-300 px-2 py-1 text-center">{row.rsp3}</td>
											<td className="border border-gray-300 px-2 py-1 text-center">{row.rsp4}</td>
											<td className="border border-gray-300 px-2 py-1 text-center">{row.rsp5}</td>
											<td className="border border-gray-300 px-2 py-1 text-center">{row.median}</td>
											{row.ref_type !== "standard" ? (
												row.ref_type === "custom" ? (
													<td colSpan="5" className="border border-gray-300 px-2 py-1 text-center">
														no data available
													</td>
												) : (
													<td colSpan="5" className="border border-gray-300 px-2 py-1 text-center">
														too few uses for rating
													</td>
												)
											) : (
												<>
													<td className="border border-gray-300 px-2 py-1 text-center">
														{row.ref_data?.split("   ")[0]}
													</td>
													<td className="border border-gray-300 px-2 py-1 text-center">
														{row.ref_data?.split("   ")[1]}
													</td>
													<td className="border border-gray-300 px-2 py-1 text-center">
														{row.ref_data?.split("   ")[2]}
													</td>
													<td className="border border-gray-300 px-2 py-1 text-center">
														{row.ref_data?.split("   ")[3]}
													</td>
													<td className="border border-gray-300 px-2 py-1 text-center">
														{row.ref_data?.split("    ")[1]}
													</td>
												</>
											)}
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}

					{/* Footer info or summary */}
					{ratingRows.length > 0 && (
						<div className="mt-4 text-xs space-y-2 px-4">
							<div>
								<p>
									Number of students responding to questionnaire:{" "}
									<span className="font-semibold">
										{class_data.qtally} out of {class_data.csize} (
										{((Number(class_data.qtally) / Number(class_data.csize)) * 100).toFixed(1)}
										%)
									</span>
									{class_data.enrollment_date &&
										` Enrolment updated on ${class_data.enrollment_date}`}
								</p>
								<p>
									Responses from this class were collected{" "}
									{class_data.webct === "Yes" ? "online" : "in person"}.
								</p>
							</div>

							<div>
								<p className="font-semibold">{labels.label}</p>
								<p>
									The reference data for the Universal Items is based on results beginning with
									Academic Year 2005/06 while other items use all data available.
								</p>
								<p className=" ">
									Information about the contents of this report may be found on the Web at:{" "}
									<a
										href="https://www.ualberta.ca/information-services-and-technology/services/test-scoring-questionnaire-services/student-perspectives-of-teaching.html"
										className="text-blue-300 underline"
									>
										https://www.ualberta.ca/information-services-and-technology/services/test-scoring-questionnaire-services/student-perspectives-of-teaching.html
									</a>
								</p>
								{comments && reportType === "indiv" && (
									<div className="text-center mt-4 ">(USRI Comments Begin Next Page)</div>
								)}
							</div>
						</div>
					)}
				</div>
			)}

			{/* Comments Section */}
			{/* In your eventual PDF you can force a page break with a CSS rule (e.g., using media print and page-break-before) */}
			{reportType === "indiv" && (
				<div className="mt-12 bg-white p-4 border border-gray-300 relative z-10 text-sm">
					<div className="absolute top-0 right-0">
						<button
							onClick={handleDownloadSingleReport}
							className="py-2 px-4 hover:cursor-pointer hover:ring-2 ring-inset underline  rounded-full text-primary transition duration-300 ease-in-out"
						>
							<span className=" font-semibold text-md">
								Download Single Report <DownloadIcon />
							</span>
						</button>
					</div>

					{/* Repeated header for the comments section */}
					<div className="text-center  ">
						<h1 className="text-md font-bold">USRI COMMENTS</h1>
					</div>

					<div className="flex justify-between items-start mb-2 text-sm">
						<div className="space-y-1">
							<p>
								Instructor: <span className="font-semibold">{header?.instructor}</span>
							</p>

							<p>
								Class: <span className="font-semibold">{header?.class_title}</span>
							</p>
							<p>
								Department: <span className="font-semibold">{header?.department}</span>
							</p>
							<p>
								Faculty: <span className="font-semibold">{header?.faculty}</span>
							</p>
						</div>
						<div className="text-right space-y-1">
							{/* <p className="font-semibold">USRI Report</p> */}
							<p>{header?.report_date}</p>
							<p>
								Academic Year: <span className="font-semibold">{header?.academic_year}</span>
							</p>
							<p>
								Catalog: <span className="font-semibold">{header?.catalog}</span>
							</p>
							{reportType !== "pub" && (
								<p>
									Requisition Number: <span className="font-semibold">{header?.requisition}</span>
								</p>
							)}
						</div>
					</div>

					{/* Comments list */}
					<div className="mt-4">
						{/* <h3 className="text-lg font-semibold mb-2">Comments</h3> */}
						{comments &&
							Object.entries(comments).map(([key, commentArray]) => {
								// Extract the item number (assuming format "(1, 21)")
								const parts = key.replace(/[()]/g, "").split(",");
								const itemNumber = parts[1]?.trim();
								const itemText = parts
									.slice(2)
									.join(",")
									.trim()
									// eslint-disable-next-line no-control-regex
									.replace(/['"\\\x00]/g, "");
								return (
									<div key={key} className="mb-4">
										<p className="font-semibold border-b-2 border-black mb-1 text-xs">
											Comment Item Number {itemNumber}:{" "}
											<span className="font-bold">{itemText}</span>
										</p>
										{commentArray.map((comment, idx) => {
											const isLast = idx === commentArray.length - 1;
											return (
												<p
													key={idx}
													className={`ml-4 text-xs ${
														!isLast ? "border-b-2 border-dotted mb-2" : ""
													}`}
												>
													{comment}
												</p>
											);
										})}
									</div>
								);
							})}
					</div>
				</div>
			)}
		</div>
	);
}
